import React from 'react';

export default function RemoteMediaLinkPanel({
  busyChoice,
  input,
  message,
  playbackOptions,
  playbackBlocked,
  selectedTargetName,
  onAction,
  onChange,
  onPaste,
  onPreview,
  onPlaySuitestream,
  preview,
  onSavePlaylist,
  onSelectResult,
  status,
}) {
  return (
    <div className="phone-remote__media-link">
      <div className="phone-remote__launcher-header">
        <strong>Add something</strong>
        <span>Paste a link or search YouTube</span>
      </div>
      <div className="phone-remote__media-link-input">
        <input
          type="search"
          inputMode="search"
          aria-label="YouTube search or media link"
          onFocus={(event) => event.currentTarget.select()}
          onClick={(event) => event.currentTarget.select()}
          value={input}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') onPreview();
          }}
          placeholder="YouTube search or media link"
          disabled={status === 'loading' || Boolean(busyChoice)}
        />
        <button
          type="button"
          className="phone-remote__primary-btn"
          onClick={onPaste}
          disabled={status === 'loading' || Boolean(busyChoice)}
        >
          {status === 'loading' ? 'Loading…' : 'Paste / Search'}
        </button>
      </div>

      {preview?.results?.length ? (
        <div className="phone-remote__media-search-results">
          <span>{preview.results.length} YouTube results</span>
          {preview.results.map((result) => (
            <button
              type="button"
              key={`${result.kind}:${result.contentId}`}
              onClick={() => onSelectResult(result)}
              disabled={Boolean(busyChoice)}
            >
              {result.thumbnailUrl ? <img src={result.thumbnailUrl} alt="" /> : null}
              <span>
                <strong>{result.title}</strong>
                <small>{result.kind === 'playlist' ? 'Playlist' : 'Video'}</small>
              </span>
            </button>
          ))}
        </div>
      ) : null}

      {preview?.media ? (
        <div className="phone-remote__media-link-result">
          <div>
            <strong>{preview.media.title}</strong>
            <span>{preview.media.provider === 'youtube' ? 'YouTube' : preview.media.provider} · {preview.media.providerKind || preview.media.kind}{preview.media.itemCount ? ` · ${preview.media.itemCount} items` : ''}</span>
          </div>
          {preview.media.provider === 'youtube' ? (
            <div className="phone-remote__media-action-card">
              <strong>Save to Suitestream</strong>
              <span>Import the playable videos into a Suitestream playlist in this area.</span>
              <button type="button" onClick={onSavePlaylist} disabled={Boolean(busyChoice)}>
                {busyChoice === 'playlist:save_area' ? 'Saving…' : 'Save to Suitestream'}
              </button>
            </div>
          ) : null}
          <div className="phone-remote__media-action-card">
            <strong>Play on {selectedTargetName || 'the selected screen'}</strong>
            {preview.media.provider === 'youtube' ? (
              <div className="phone-remote__media-device-row">
                <span>{playbackOptions?.suitestream?.target.name || 'Suitestream player unavailable on this screen'}</span>
                <button
                  type="button"
                  className="phone-remote__media-play-now"
                  onClick={() => onPlaySuitestream(playbackOptions.suitestream)}
                  disabled={Boolean(busyChoice) || playbackBlocked || !playbackOptions?.suitestream}
                >
                  {busyChoice === 'suitestream:play' ? 'Starting…' : 'Play in Suitestream'}
                </button>
              </div>
            ) : null}
            {(playbackOptions?.apps || []).map(({ choice, device }) => (
              <div key={choice.profileId} className="phone-remote__media-app-group">
                <div className="phone-remote__media-device-row">
                  <span>{device.target.name}</span>
                  <button
                    type="button"
                    onClick={() => onAction(choice, 'open', device)}
                    disabled={Boolean(busyChoice) || playbackBlocked}
                  >
                    {busyChoice === `${choice.profileId}:open` ? 'Opening…' : `Play in ${choice.adapterKey === 'youtube' ? 'YouTube' : choice.appName}`}
                  </button>
                </div>
                {preview.media.provider !== 'youtube' ? (
                  <button type="button" onClick={() => onAction(choice, 'save_area')} disabled={Boolean(busyChoice)}>
                    {busyChoice === `${choice.profileId}:save_area` ? 'Saving…' : `Save ${choice.appName} link to area`}
                  </button>
                ) : null}
              </div>
            ))}
            {!playbackOptions?.apps?.length ? (
              <span>No compatible installed app is available on this screen’s configured sources.</span>
            ) : null}
            <span>If playback needs another input, you’ll be asked before it switches.</span>
          </div>
        </div>
      ) : null}
      {message ? (
        <div className={`phone-remote__notice${status === 'error' ? ' phone-remote__notice--error' : ''}`}>
          {message}
        </div>
      ) : null}
    </div>
  );
}
